import { useEffect, useState } from 'react';
import { AxiosResponse } from 'axios';
import { GetServerSidePropsContext } from 'next';
import * as cookie from 'cookie';

import { localLogin, localLogout, localSession } from '@common/endpoints';

import localApiRequest from './localApiRequest';

interface TokenData {
  token: string;
}

export const storeAccessToken = async (data: TokenData) => {
  await localApiRequest.post(localLogin(), {
    accessToken: data.token,
  });
};

export const clearAccessToken = async () => {
  await localApiRequest.get(localLogout());
};

export const getSession = async () =>
  localApiRequest
    .get(localSession())
    .then((response: AxiosResponse<{ accessToken: string }>) => response.data);

export const useSession = (): string | undefined => {
  const [session, setSession] = useState<string>();

  useEffect(() => {
    const fetchSession = async () => {
      const response = await getSession();

      setSession(response.accessToken);
    };

    fetchSession();
  });

  return session;
};

export const getAccessToken = (req: GetServerSidePropsContext['req']) => {
  return cookie.parse(req.headers.cookie || '').accessToken;
};
